import React from 'react';
import PageHeader from '../Components/common/PageHeader';
import Partners02 from '../Components/Partners/Partners02';
import TopFeatures from '../Components/TopFeatures';
import Banner from '../Containers/Banner';
import ExperienceAbout from '../Containers/Experiences/ExperienceAbout';
import FunFactAbout from '../Containers/Funfacts/FunFactAbout';
import Team from '../Containers/Team';
import Testimonial01 from '../Containers/Testimonials/Testimonial01';

const About = () => {
    const AboutBannerData = {
        title: 'Costruisci la tua casa dei sogni',
        heading: 'Affidati ai professionisti',
        phone: '+39 340 5327626'
    }

    return (
        <>
            <PageHeader 
                activeClass01='active' 
                activeClass02='d-none' 
                routeName01='Chi Siamo' 
                heading='RB Costruzioni - Innovazione e Sostenibilità nella Costruzione' 
            />

            <div className="main_wrapper">
                {/* Top Features Section - showing core services */}
                {/* <TopFeatures /> */}

                {/* Experience Section - highlighting years in the industry */}
                <ExperienceAbout 
                    title="17 Anni di Esperienza nel Settore"
                    description="Con oltre 17 anni di esperienza, RB Costruzioni è il partner ideale per la costruzione e ristrutturazione della tua casa."

                />

                {/* Fun Facts Section - showcasing the achievements */}
                {/* <FunFactAbout 
                    facts={[
                        { number: 17, label: 'Anni di Esperienza' },
                        { number: 320, label: 'Progetti Completati' },
                        { number: 20, label: 'Costruttori Esperti' },
                        { number: 8, label: 'Progetti in Corso' }
                    ]}
                />  */}

                {/* Team Section - highlight the expert team */}
               {/* <Team pb='pd_btom_110' /> */}

                {/* Banner Section - call-to-action for contacting the company */}

                
                <Banner
                    title="Realizza la tua casa con noi"
                    heading="Contattaci per una consulenza" 
                    phone="+39 340 5327626"
                    bannerType="banner type_3 banner_bg_color"
                    style={{
                        backgroundColor: '#000',
                        padding: '50px 0',
                        marginBottom: '50px'
                    }}
                />

                {/* Testimonials - highlight client feedback */}
                {/* <Testimonial01 pb='pd_btom_110' /> */}

                {/* Partners Section - showcase trusted partners */}
                {/* <Partners02 pt='pd_tp_110' /> */}
            </div>
        </>
    );
};

export default About;
